module.exports = __webpack_public_path__ + "img/1.cb2f3f0a.jpg";